import cn from 'classnames';
import { useRouter } from 'next/router';
import { useEffect, useRef } from 'react';
import { checkIconMenu } from 'src/components/LeftColumn/helpers/viewMenu';
import { CustomDialogRubricMenu, DialogRubricMenu } from 'src/components/RubricsMenu/components';
import { TABLE_WIDTH } from 'src/constants/common';

import { Icon, Button } from '@sravni/react-design-system';
import { Menu } from '@sravni/react-icons';
import { useBoolean, useIsPhone } from '@sravni/react-utils';

import styles from './mobilemenudialog.module.scss';

interface MobileMenuDialogProps {
  subscriptionPopupState: [number, (value: number) => void];
}

export const MobileMenuDialog = ({ subscriptionPopupState }: MobileMenuDialogProps) => {
  const {
    query: { rubric, organizationAlias },
  } = useRouter();
  const isMobile = useIsPhone();
  const iconRef = useRef<HTMLButtonElement>(null);
  const [isViewDialogMenu, setIsViewDialogMenu] = useBoolean(false);
  const [isViewIconMenu, setIsViewIconMenu] = useBoolean(false);
  const handleViewDialogRubricMenu = () => {
    setIsViewDialogMenu.toggle();
  };

  const isPartnersNews = Boolean(organizationAlias) || rubric === 'novosti-partnerov';

  useEffect(() => {
    if (!isMobile) {
      const checkWindowHeight = () => {
        const windowInnerWidth = window.innerWidth;

        if (windowInnerWidth <= TABLE_WIDTH) {
          setIsViewIconMenu.off();
        } else {
          const res = checkIconMenu();
          res ? setIsViewIconMenu.off() : setIsViewIconMenu.on();
        }
      };

      const loadHandler = () => {
        const res = checkIconMenu();
        res ? setIsViewIconMenu.off() : setIsViewIconMenu.on();
      };

      !isPartnersNews && checkWindowHeight();
      isPartnersNews && loadHandler();

      window.addEventListener('resize', checkWindowHeight);
      window.addEventListener('load,', loadHandler);
      window.addEventListener('visibilitychange', checkWindowHeight);
      return () => {
        window.removeEventListener('resize', checkWindowHeight);
        window.removeEventListener('load,', loadHandler);
        window.removeEventListener('visibilitychange', checkWindowHeight);
      };
    }
  }, [isMobile, isPartnersNews, setIsViewIconMenu]);

  return (
    <>
      <Button
        ref={iconRef}
        variant="primary"
        size={52}
        color="blue"
        className={cn(styles.icon, { [styles['icon--hide']]: isViewIconMenu })}
        onClick={setIsViewDialogMenu.on}
      >
        <Icon size={20} icon={<Menu />} className={styles.menu} />
      </Button>

      {isMobile ? (
        <DialogRubricMenu
          subscriptionPopupState={subscriptionPopupState}
          view={isViewDialogMenu}
          closeView={handleViewDialogRubricMenu}
        />
      ) : (
        <CustomDialogRubricMenu
          subscriptionPopupState={subscriptionPopupState}
          view={isViewDialogMenu}
          closeView={handleViewDialogRubricMenu}
        />
      )}
    </>
  );
};
